import type { EntityFormsOverride } from '@/entity-config-runtime/entity-forms'
import type { EntityFormConfigOverride } from '@/entity-config-runtime/form-config-overrides'
import type { FormField } from '@/shared/forms/utility/composed'

const rolesFormsOverride: EntityFormsOverride = (generatedConfig) => {
	const userGroupField = {
		name: 'userGroupId',
		label: 'forms_roles_user_group',
		type: 'autocompleteUserGroups',
	} as unknown as FormField

	const createFields = generatedConfig?.create?.[0]?.fields
	if (
		createFields &&
		!createFields.some((field) => field.name === 'userGroupId')
	) {
		createFields.push({ ...userGroupField })
	}

	const editFields = generatedConfig?.edit?.[0]?.fields
	if (editFields && !editFields.some((field) => field.name === 'userGroupId')) {
		editFields.push({ ...userGroupField })
	}

	return generatedConfig
}

export const entityFormConfigOverride: EntityFormConfigOverride = {
	entity: 'roles',
	override: rolesFormsOverride,
}
